/*
https://splidejs.com/guides/getting-started/
*/

import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener( 'DOMContentLoaded', function() {

    if (('.carousel-slider').length) {
        const carouselSlider = document.querySelector('.carousel-slider');
        if( carouselSlider ) {
            // Get the autoStart value from data attribute
            const autoStartValue = carouselSlider.dataset.autoStart === 'true';
            
            // Build the options object conditionally
            let splideOptions = {
                type        : autoStartValue ? 'loop' : 'slide',
                drag        : 'free',
                focus       : 'center',
                direction   : 'ltr', // Explicitly set to LTR to prevent RTL issues
                perPage     : 3,
                autoWidth   : true,
                // gap         : '6em',
                arrows      : false,
                pagination  : false,
                // Add additional RTL-related options
                i18n: {
                    prev: 'Previous slide',
                    next: 'Next slide',
                },
                breakpoints : {
                    768: {
                        perPage: 1,
                    },
                    960: {
                        perPage: 2,
                    },
                    1100: {
                        perPage: 3,
                    },
                }
            };

            // Only add autoScroll if autoStart is true
            if (autoStartValue) {
                splideOptions.autoScroll = {
                    speed: -1,
                };
            }
            
            var splideCarousel = new Splide( '.carousel-slider', splideOptions );
            
            // Mount with or without AutoScroll based on autoStart value
            if (autoStartValue) {
                splideCarousel.mount( { AutoScroll } );
            } else {
                splideCarousel.mount();
            }
        }
    }
});